(() => {
  if (window.NhoiWearingCards) {
    window.NhoiWearingCards.refresh();
    return;
  }

  const selector = '.product-card';
  const galleries = new Map();
  let templates = new Map();
  let nativeControls;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function dispose(card, failed = false) {
    const gallery = galleries.get(card);
    if (!gallery) return;
    gallery.abort.abort();
    gallery.track.replaceWith(gallery.main);
    gallery.main.classList.remove('nhoi-wear-slide');
    gallery.controls.remove();
    gallery.wrapper.classList.toggle('product-card__image-wrapper--main-only', gallery.wasMainOnly);
    if (gallery.originalSecond) gallery.originalSecond.style.display = gallery.originalSecondDisplay;
    card.classList.remove('nhoi-card--wearable');
    if (failed) card.dataset.nhoiWearingFailed = gallery.sourceKey;
    galleries.delete(card);
  }

  function enhance(card) {
    const key = card.dataset.nhoiWearingKey;
    const template = templates.get(key);
    if (galleries.has(card)) return;
    const sourceKey = template ? `wear:${key}` : 'native';
    if (card.dataset.nhoiWearingFailed === sourceKey) return;
    const wrapper = card.querySelector('.product-card__image-wrapper');
    const main = wrapper?.querySelector('.product-card__image--main');
    if (!main?.querySelector('img')) return;
    const originalSecond = wrapper.querySelector('.product-card__image--second');
    const second = (template?.content.querySelector('[data-nhoi-wear-second]') || originalSecond)?.cloneNode(true);
    const controls = (template?.content.querySelector('.nhoi-wear-controls') || nativeControls?.content.querySelector('.nhoi-wear-controls'))?.cloneNode(true);
    if (!second?.querySelector('img') || !controls) return;
    second.className = 'media-wrapper nhoi-wear-slide nhoi-wear-slide--second';
    second.style.removeProperty('display');
    const wasMainOnly = wrapper.classList.contains('product-card__image-wrapper--main-only');
    const originalSecondDisplay = originalSecond?.style.display || '';
    const track = document.createElement('div');
    track.className = 'nhoi-wear-track';
    track.style.setProperty('--nhoi-wear-ratio', main.style.getPropertyValue('--aspect-ratio') || '1');
    main.before(track);
    main.classList.add('nhoi-wear-slide');
    track.append(main, second);
    wrapper.append(controls);
    wrapper.classList.add('product-card__image-wrapper--main-only');
    if (originalSecond) originalSecond.style.display = 'none';
    card.classList.add('nhoi-card--wearable');
    const abort = new AbortController();
    const signal = abort.signal;
    const dots = Array.from(controls.querySelectorAll('[data-nhoi-wear-index]'));
    galleries.set(card, { track, main, wrapper, controls, wasMainOnly, originalSecond, originalSecondDisplay, sourceKey, abort });

    function setActive(index) {
      dots.forEach((dot, position) => {
        dot.classList.toggle('is-active', position === index);
        dot.setAttribute('aria-pressed', String(position === index));
      });
    }

    function show(index) {
      const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      track.scrollTo({ left: direction * index * track.clientWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    }

    track.addEventListener('scroll', () => {
      if (track.clientWidth) setActive(Math.min(1, Math.round(Math.abs(track.scrollLeft) / track.clientWidth)));
    }, { passive: true, signal });
    controls.addEventListener('click', event => {
      const button = event.target.closest('[data-nhoi-wear-index]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      show(Number(button.dataset.nhoiWearIndex));
    }, { signal });
    card.addEventListener('pointerenter', event => {
      if (finePointer.matches && event.pointerType === 'mouse') show(1);
    }, { signal });
    card.addEventListener('pointerleave', event => {
      if (finePointer.matches && event.pointerType === 'mouse') show(0);
    }, { signal });
    second.querySelector('img')?.addEventListener('error', () => dispose(card, true), { once: true, signal });
  }

  function scan(root) {
    if (root.matches?.(selector)) enhance(root);
    root.querySelectorAll?.(selector).forEach(enhance);
  }

  function refresh() {
    Array.from(galleries.keys()).forEach(card => dispose(card));
    templates = new Map(Array.from(document.querySelectorAll('[data-nhoi-wearing-template]')).map(template => [template.dataset.nhoiWearingTemplate, template]));
    document.querySelectorAll(selector).forEach(card => delete card.dataset.nhoiWearingFailed);
    nativeControls = document.querySelector('[data-nhoi-native-controls]');
    scan(document);
  }

  window.NhoiWearingCards = { refresh };
  refresh();
  new MutationObserver(records => {
    let configChanged = false;
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (node.matches('[data-nhoi-wearing-config]') || node.querySelector('[data-nhoi-wearing-config]')) configChanged = true;
        else scan(node);
      }
      for (const node of record.removedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE && (node.matches('[data-nhoi-wearing-config]') || node.querySelector('[data-nhoi-wearing-config]'))) configChanged = true;
      }
    }
    for (const card of galleries.keys()) if (!card.isConnected) dispose(card);
    if (configChanged) refresh();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', refresh);
})();
